<template>
  <div class="suggestions">
    <p>{{$t('common.tag_input.item_length_over', {character_limit: props.tag.character_limit})}}</p>
    <p>{{ $t('common.tag_input.click_item_to_edit') }} </p>
    <div style="text-align: right; margin: 0">
        <el-button type="primary" size="mini" @click="props.tag.suggestion_visible = false">{{ $t('common.ok') }}</el-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
        props: {
            type: Object
        },
    },
    computed: {
    },
  }
</script>

<style lang="scss" scoped>
    
</style>
